export const REACT_APP_API_KEY = 'AIzaSyC2sHQy-RixhDIj1a3c6fe_jwvQZwPefiA';
export const REACT_APP_AUTH_DOMAIN = 'portal-upstreamcoding.firebaseapp.com';
export const REACT_APP_DATABASE_URL = 'https://portal-upstreamcoding.firebaseio.com';
export const REACT_APP_PROJECT_ID = 'portal-upstreamcoding';
export const REACT_APP_STORAGE_BUCKET = 'portal-upstreamcoding.appspot.com';
export const REACT_APP_MESSAGING_SENDER_ID = '558430000570';
export const AUTH_ACTION_RESET_PW = 'resetPassword';
export const AUTH_ACTION_RECOVER_EMAIL = 'recoverEmail';
export const AUTH_ACTION_VERIFY_EMAIL = 'verifyEmail';
